@if (data(); as d) {
  <div class="bw-popup" [class.bw-popup--birth]="d.state === 'birth'" [class.bw-popup--different]="d.state === 'different'">
    <header class="bw-popup__header">
      <span class="bw-popup__property">{{ d.propertyLabel }}</span>
      <span class="bw-popup__state">{{ d.stateLabel }}</span>
    </header>
    <div class="bw-popup__value">{{ d.valueLabel }}</div>

    <dl class="bw-popup__times">
      <dt>{{ d.fromLabel }}</dt><dd>{{ d.fromText }}</dd>
      <dt>{{ d.toLabel }}</dt><dd>{{ d.toText }}</dd>
      <dt>{{ d.durationLabel }}</dt><dd>{{ d.durationText }}</dd>
    </dl>
    <div class="bw-popup__utc">{{ d.utcText }}</div>

    <section class="bw-popup__causes">
      <h4>{{ d.causesLabel }}</h4>
      @if (d.causes.length === 0) {
        <p class="bw-popup__nocause">{{ d.noCauseText }}</p>
      } @else {
        <ul>
          @for (cause of d.causes; track $index) {
            <li>
              <span class="bw-popup__glyph" aria-hidden="true">{{ cause.glyph }}</span>
              <span class="bw-popup__planet">{{ cause.planet }}</span>
              <span class="bw-popup__side">{{ cause.side }}</span>
              <span class="bw-popup__shift">{{ cause.from }} → {{ cause.to }}</span>
            </li>
          }
        </ul>
      }
    </section>

    @if (d.setTimeMs !== undefined) {
      <div class="bw-popup__actions">
        <button eBtn size="sm" color="primary-75" icon="location-crosshairs" type="button" (click)="setTimeHere()">
          {{ d.setTimeLabel }}
        </button>
      </div>
    }
  </div>
}
